import { createWorker } from 'tesseract.js'
import { readSportsMetadata, sportsSearchTerms } from './sportsMetadata'
import type { CardCandidate, ScanResult } from './types'

// A separate worker and layout: no Magic OCR crops, corrections or thresholds.
export async function recognizeSportsCard(
  canvas: HTMLCanvasElement,
  onProgress: (label: string) => void,
): Promise<ScanResult & { metadata: Partial<CardCandidate> }> {
  const worker = await createWorker('eng', undefined, {
    logger: message => {
      if (message.status) onProgress(`Reading sports card: ${Math.round((message.progress ?? 0) * 100)}%`)
    },
  })
  const texts: string[] = []
  try {
    await worker.setParameters({ tessedit_pageseg_mode: '11' as Tesseract.PSM, preserve_interword_spaces: '1' })
    // Full front plus enlarged top/slab label and bottom/name areas. No back scan.
    for (const region of [{ y: 0, h: 1 }, { y: 0, h: 0.28 }, { y: 0.65, h: 0.35 }]) {
      const crop = document.createElement('canvas')
      const scale = region.h === 1 ? 1 : 2
      crop.width = canvas.width * scale
      crop.height = Math.round(canvas.height * region.h * scale)
      const context = crop.getContext('2d')
      if (!context) throw new Error('Could not prepare the sports card image.')
      try {
        context.drawImage(canvas, 0, canvas.height * region.y, canvas.width, canvas.height * region.h, 0, 0, crop.width, crop.height)
        texts.push((await worker.recognize(crop)).data.text)
      } finally {
        crop.width = crop.height = 1
      }
    }
  } finally {
    await worker.terminate()
  }
  const rawText = texts.join('\n').trim()
  const metadata = readSportsMetadata(rawText)
  return { rawText, terms: sportsSearchTerms(rawText), setCodes: [], collectorNumbers: metadata.collectorNumber ? [metadata.collectorNumber] : [], metadata }
}
